/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaRowStatiIndexRange model module.
 * @module model/AqaRowStatiIndexRange
 * @version v0
 */
export default class AqaRowStatiIndexRange {
  /**
   * Constructs a new <code>AqaRowStatiIndexRange</code>.
   * @alias module:model/AqaRowStatiIndexRange
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaRowStatiIndexRange</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaRowStatiIndexRange} obj Optional instance to populate.
   * @return {module:model/AqaRowStatiIndexRange} The populated <code>AqaRowStatiIndexRange</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaRowStatiIndexRange();
      if (data.hasOwnProperty('start'))
        obj.start = ApiClient.convertToType(data['start'], 'Number');
      if (data.hasOwnProperty('end'))
        obj.end = ApiClient.convertToType(data['end'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {Number} start
 */
AqaRowStatiIndexRange.prototype.start = undefined;

/**
 * @member {Number} end
 */
AqaRowStatiIndexRange.prototype.end = undefined;

